import $ from 'jquery';

class OverlaySearch {
    // 1. describe and create/initiate our object.
    constructor() {
        this.addSearchHTML();
        this.resultsDiv = $("#search-overlay__result");
        this.openButton = $(".js-search-trigger");
        this.closeButton = $(".search-overlay__close");
        this.searchOverlay = $(".search-overlay");
        this.searchField = $("#search-term");
        this.isOverlayOpen = false;
        this.isSpinnerVisible = false;
        this.previousValue;
        this.typingTimer;
        this.events();
    }

    // 2. events or dispacher
    events() {
        this.openButton.on("click", this.openOverlay.bind(this));
        this.closeButton.on("click", this.closeOverlay.bind(this));
        $(document).on("keydown", this.keyPressDispatcher.bind(this));
        this.searchField.on("keyup", this.typingLogic.bind(this));
    }

    // 3. methods (function, action...)
    typingLogic() {
        if(this.searchField.val() != this.previousValue) {
            // Clear timer if we press key before timer timeout. 
            clearTimeout(this.typingTimer);

            if(this.searchField.val()) {
                if(!this.isSpinnerVisible) {
                    // add loading spinner
                    this.resultsDiv.html('<div class="spinner-loader"></div>');
                    this.isSpinnerVisible = true;
                }
    
                // 2nd arg is time in milisecon
                this.typingTimer = setTimeout(this.getResults.bind(this), 900);
            } else {
                this.resultsDiv.html('');
                this.isSpinnerVisible = false;
            }            
        }
        this.previousValue = this.searchField.val();
    }

    getResults() {
        // Asyncronus request.
        $.when(
            $.getJSON(themeJsData.root_url + '/wp-json/wp/v2/posts?search=' + this.searchField.val()), 
            $.getJSON(themeJsData.root_url + '/wp-json/wp/v2/shader?search=' + this.searchField.val())
            ).then((posts, pages) => {
                /*On succed*/
                var combinedResults = posts[0].concat(pages[0]);
                this.resultsDiv.html(`
                    <h2 class="search-overlay__section-title"> General Information </h2> 

                    ${combinedResults.length ? '<ul class="link-list min-list">' : '<p> No general information matches that search </p>'}                
                        ${combinedResults.map(item => `<li> <a href="${item.link}"> ${item.title.rendered} </a> </li> `)} 
                    ${combinedResults.length ? '</ul>' : ' '}
                `);
                this.isSpinnerVisible = false;
            }, /*On error occur*/ () => {
                this.resultsDiv.html(`<p> Unexpected error; please try again.</p>`);
            });        
    }

    keyPressDispatcher(e) {
        if(e.keyCode == 83 && !this.isOverlayOpen && !$("input, textarea").is(':focus')) {
            this.openOverlay();
        }
        if(e.keyCode == 27 && this.isOverlayOpen) {
            this.closeOverlay();
        }
    }
    openOverlay() {        
        this.searchOverlay.addClass("search-overlay--active");
        $("body").addClass("body-no-scroll");
        this.searchField.val('');
        setTimeout(() => {this.searchField.focus();}, 300);
        this.isOverlayOpen = true;
    }
    closeOverlay() {
        this.searchOverlay.removeClass("search-overlay--active");
        $("body").removeClass("body-no-scroll");
        this.isOverlayOpen = false;
    }

    addSearchHTML() {
        $("body").append(`
            <div class="search-overlay">
                <div class="search-overlay__top">
                    <div class="container">
                        <i class="fa fa-search search-overlay__icon" area-hidden="true"></i>
                        <input type="text" class="search-term" placeholder="What are you looking for?" id="search-term">
                        <i class="fa fa-window-close search-overlay__close" area-hidden="true"></i>
                    </div>
                </div>
                <div class="container">
                    <div id="search-overlay__result">
                    </div>
                </div>
            </div>
        `);
    }
}

export default OverlaySearch; 